export const ROUTES = {
    TASK_DETAILS: (orgName: string, taskFriendlyId: number) => `/task/${orgName}-${taskFriendlyId}`,
    PLAN_FEATURES: (planId: string) => `/superadmin/plan-feature/${planId}`,
    PLANS : () => `/superadmin/plans`,
    
    // Module routes
    TEAM: () => `/dashboard/owner/team`,
    REPORTS: () => `/owner/reports`,
    ANALYTICS: () => `/owner/analytics`,

    // Billing routes
    PRICIMG : () => `/dashboard/owner/pricing`,
    Payment : (planId : string) => `/dashboard/owner/payment/${planId}`,
    BillingDetails : () => `/dashboard/owner/billing-details`,
    BillingDetailsByOrgId : (orgId : number) => `/dashboard/superadmin/billing-details/${orgId}`,
    ReferralPage : () => `/dashboard/owner/my-referrals`,
    Forbidden: () => `/forbidden`,

}